import { PriceUtils } from '@wix/bookings-uou-mappers';
import { useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { ServicePaymentDetails } from '../../../../../types/types';
import Text, { TextType } from '../../../Text/Text';
import { PaymentSummaryDataHook } from '../dataHooks';
import { classes } from '../PaymentSummary.st.css';
import { PriceItem } from '../PriceItem/PriceItem';

type SubscriptionSummaryProps = {
  price: number;
  currency: string;
  locale: string;
  paymentDetails: ServicePaymentDetails;
  isCart: boolean | undefined;
};

export const SubscriptionSummary: React.FC<SubscriptionSummaryProps> = ({
  price,
  currency,
  locale,
  paymentDetails,
  isCart,
}) => {
  const { t } = useTranslation();

  const enrollmentFeeValue = paymentDetails.subscriptionInfo
    ?.enrollmentFeeAmount
    ? Number(paymentDetails.subscriptionInfo.enrollmentFeeAmount.value)
    : 0;

  const info = paymentDetails.subscriptionInfo;

  return (
    <div className={classes.singleSession}>
      <div className={classes.details}>
        <PriceItem
          type={TextType.Secondary}
          labels={[t('app.payment.summary.subscription.label')]}
          price={t('app.payment.summary.subscription.monthly-price', {
            price: PriceUtils.getFormattedCurrency({
              price,
              currency,
              locale,
            }),
          })}
          ariaPrice={PriceUtils.getFormattedCurrency({
            price,
            currency,
            locale,
            currencyDisplay: 'name',
          })}
          dataHook={PaymentSummaryDataHook.Subscription_Price}
          isCart={isCart}
        />
        {info && (
          <div>
            <Text type={TextType.Secondary}>
              {t('app.payment.summary.subscription.info', {
                count: info.totalPayments,
              })}
            </Text>
          </div>
        )}
        {paymentDetails.subscriptionInfo?.enrollmentFeeAmount && (
          <PriceItem
            type={TextType.Secondary}
            labels={[t('app.payment.summary.enrollment-fee.label')]}
            price={PriceUtils.getFormattedCurrency({
              price: enrollmentFeeValue,
              currency,
              locale,
            })}
            ariaPrice={PriceUtils.getFormattedCurrency({
              price: enrollmentFeeValue,
              currency,
              locale,
              currencyDisplay: 'name',
            })}
            dataHook={PaymentSummaryDataHook.Enrollment_Fee}
            isCart={isCart}
          />
        )}
        <Divider className={classes.divider} />
        <PriceItem
          type={TextType.Primary}
          labels={[t('app.payment.summary.pay-now.label')]}
          price={PriceUtils.getFormattedCurrency({
            price: price + enrollmentFeeValue,
            currency,
            locale,
          })}
          ariaPrice={PriceUtils.getFormattedCurrency({
            price: price + enrollmentFeeValue,
            currency,
            locale,
            currencyDisplay: 'name',
          })}
          dataHook={PaymentSummaryDataHook.Pay_Now}
          isCart={isCart}
        />
      </div>
    </div>
  );
};
